export default function AreasOfSupport() {
  const topics = [
    {
      title: "Understanding the Root Cause",
      description:
        "Real change begins with understanding. Explore the thoughts, emotions and life experiences that may be influencing your relationship with alcohol. Together, we\u2019ll look beyond the drinking itself to understand why alcohol has become your way of coping.",
    },
    {
      title: "Understanding the Role of Shame",
      description:
        "Shame keeps people stuck. Understanding sets them free. Discover how shame can fuel the cycle of drinking, silence and self-criticism, and learn how developing self-awareness and self-compassion can help you move forward with greater confidence.",
    },
    {
      title: "Building Awareness & Recognising Your Triggers",
      description:
        "Awareness is the first step towards lasting change. Learn to recognise the situations, emotions, environments and thinking patterns that may trigger the urge to drink, so you can respond with greater intention rather than reacting automatically.",
    },
    {
      title: "Interrupting Unhelpful Patterns",
      description:
        "Small changes can create lasting transformation. Identify the habits and routines that keep the cycle going and discover practical strategies to interrupt those patterns and build healthier ways of responding to life\u2019s challenges.",
    },
    {
      title: "Rebuilding Self-Trust & Confidence",
      description:
        "Keep the promises you make to yourself. Recovery is about more than changing your drinking. It\u2019s about rebuilding confidence in yourself, strengthening self-belief and learning to trust your own decisions again.",
    },
    {
      title: "Creating a Life You Don\u2019t Want to Escape From",
      description:
        "Recovery is about building a future, not just leaving the past behind. Develop healthier daily routines, greater emotional resilience and a clearer sense of purpose, so you can create a calmer, more fulfilling life\u2014one that feels genuinely aligned with who you want to become.",
    },
  ];

  return (
    <section className="w-full bg-background-100 py-12 md:py-20">
      <div className="w-full px-4 sm:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-foreground-950 mb-4">
              How This Programme Can Help You&hellip;
            </h2>
            <p className="font-body text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
              Everyone&rsquo;s journey is different. You&rsquo;ll explore the emotional, psychological and behavioural patterns behind your drinking while developing practical strategies to support positive change.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 stagger-children">
            {topics.map((item) => (
              <div
                key={item.title}
                className="bg-background-50 rounded-lg p-6 md:p-7 border border-background-200/50 hover:border-primary-200/50 transition-all duration-500"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                  <span className="text-base">🌿</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-medium text-foreground-900 mb-3">
                  {item.title}
                </h3>
                <p className="font-body text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}